import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "wrap client-list" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "Liste des clients", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Inclure les clients dont les projets sont archivés", -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  key: 3,
  class: "actions"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h3", null, "Informations du client", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_user_add_outlined = _resolveComponent("user-add-outlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_a_row, {
          key: 0,
          type: "flex"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, {
              span: 24,
              align: "center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_spin, { size: "large" })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _hoisted_2,
          _createVNode(_component_a_row, {
            type: "flex",
            class: "search-row"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, {
                offset: 4,
                span: 16,
                align: "center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_space, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        class: "input-search",
                        value: _ctx.searchText,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchText) = $event)),
                        placeholder: "Rechercher un client (Nom / Société, Projet)",
                        style: {"width":"600px"}
                      }, null, 8, ["value"]),
                      _createVNode(_component_a_switch, {
                        checked: _ctx.includeClientWithArchivedProjects,
                        "onUpdate:checked": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.includeClientWithArchivedProjects) = $event))
                      }, null, 8, ["checked"]),
                      _hoisted_3
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_row, {
            type: "flex",
            class: "inclure-clients-row"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    type: "primary",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showCreateOrUpdateClient()))
                  }, {
                    icon: _withCtx(() => [
                      _createVNode(_component_user_add_outlined)
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(" Créer un client ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_row, { type: "flex" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_table, {
                    columns: _ctx.clientsColumns,
                    "data-source": _ctx.clientsDatasource,
                    loading: _ctx.isLoadingTable,
                    bordered: ""
                  }, {
                    headerCell: _withCtx(({ column }) => [
                      _createElementVNode("strong", null, _toDisplayString(column.title), 1)
                    ]),
                    bodyCell: _withCtx(({ column, record }) => [
                      (column.key === 'dateCreation')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.obtenirDateAffichage(record)), 1))
                        : (column.key === 'projets')
                          ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.projets, (projet, idx) => {
                                return (_openBlock(), _createElementBlock("li", { key: idx }, _toDisplayString(projet), 1))
                              }), 128))
                            ]))
                          : (column.key === 'client')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                _createElementVNode("strong", null, _toDisplayString(_ctx.obtenirCiviliteAffichage(record)) + " " + _toDisplayString(_ctx.obtenirNomAffichage(record)), 1),
                                _hoisted_6,
                                _createElementVNode("span", null, _toDisplayString(record.adresse), 1),
                                _hoisted_7,
                                (record.adresseComplement)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createElementVNode("span", null, _toDisplayString(record.adresseComplement), 1),
                                      _hoisted_8
                                    ], 64))
                                  : _createCommentVNode("", true),
                                _createElementVNode("span", null, _toDisplayString(record.codePostal) + " " + _toDisplayString(record.ville), 1),
                                _hoisted_9,
                                _createElementVNode("span", null, _toDisplayString(_ctx.obtenirContactAffichage(record)), 1),
                                _hoisted_10,
                                (record.email)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(record.email), 1))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : (column.key === 'action')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                  _createVNode(_component_a_row, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_button, {
                                        onClick: ($event: any) => (_ctx.navigateToEstimatifClient(record))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(" Projets ")
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"])
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_a_row, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_col, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_button, {
                                            onClick: ($event: any) => (_ctx.showCreateOrUpdateClient(record))
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(" Modifier ")
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"]),
                                          _createVNode(_component_a_popconfirm, {
                                            title: "Êtes-vous sûr de vouloir supprimer le client ?",
                                            onConfirm: ($event: any) => (_ctx.supprimer(record)),
                                            "ok-text": "Supprimer",
                                            "cancel-text": "Annuler"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_a_button, {
                                                danger: "",
                                                loading: record.estEnCoursSuppression
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(" Supprimer ")
                                                ]),
                                                _: 2
                                              }, 1032, ["loading"])
                                            ]),
                                            _: 2
                                          }, 1032, ["onConfirm"])
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]))
                              : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["columns", "data-source", "loading"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_modal, {
            visible: _ctx.createOrUpdateClientIsVisible,
            "onUpdate:visible": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.createOrUpdateClientIsVisible) = $event)),
            title: _ctx.modalCreateOrUpdateTitle,
            footer: null
          }, {
            default: _withCtx(() => [
              (_ctx.createOrUpdateClient)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _hoisted_13,
                    _createVNode(_component_a_form, {
                      model: _ctx.createOrUpdateClient,
                      "validate-messages": _ctx.validateMessages,
                      "label-col": { style: { width: '150px' } },
                      autocomplete: "off",
                      onFinish: _ctx.submitCreateOrUpdateClientHandler
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, { label: "Civilité" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_select, {
                              value: _ctx.createOrUpdateClient.civiliteId,
                              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.createOrUpdateClient.civiliteId) = $event))
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.civilites, (civilite) => {
                                  return (_openBlock(), _createBlock(_component_a_select_option, {
                                    key: civilite.civiliteId,
                                    value: civilite.civiliteId
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(civilite.code), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["value"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_form_item, {
                          name: ['nom'],
                          label: "Nom / Société",
                          rules: [{ required: true }],
                          "has-feedback": ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: _ctx.createOrUpdateClient.nom,
                              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.createOrUpdateClient.nom) = $event)),
                              placeholder: "Nom / Société"
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_form_item, { label: "Prénom" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: _ctx.createOrUpdateClient.prenom,
                              "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.createOrUpdateClient.prenom) = $event)),
                              placeholder: "Prénom"
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_form_item, { label: "Adresse" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: _ctx.createOrUpdateClient.adresse,
                              "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.createOrUpdateClient.adresse) = $event)),
                              placeholder: "Adresse"
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_form_item, { label: "Adresse Complément" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: _ctx.createOrUpdateClient.adresseComplement,
                              "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.createOrUpdateClient.adresseComplement) = $event)),
                              placeholder: "Adresse Complément"
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_form_item, { label: "Code Postal" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: _ctx.createOrUpdateClient.codePostal,
                              "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.createOrUpdateClient.codePostal) = $event)),
                              placeholder: "Code Postal"
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_form_item, { label: "Ville" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: _ctx.createOrUpdateClient.ville,
                              "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.createOrUpdateClient.ville) = $event)),
                              placeholder: "Ville"
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_form_item, { label: "Téléphone" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: _ctx.createOrUpdateClient.telephone,
                              "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.createOrUpdateClient.telephone) = $event)),
                              placeholder: "Téléphone"
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_form_item, { label: "Portable" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: _ctx.createOrUpdateClient.portable,
                              "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.createOrUpdateClient.portable) = $event)),
                              placeholder: "Portable"
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_form_item, { label: "Email" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: _ctx.createOrUpdateClient.email,
                              "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.createOrUpdateClient.email) = $event)),
                              placeholder: "Email",
                              max: 255
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_form_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_button, {
                              type: "primary",
                              "html-type": "submit"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.createOrUpdateClient.clientId > 0 ? "Mettre à jour" : "Créer"), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["model", "validate-messages", "onFinish"])
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["visible", "title"])
        ], 64))
  ]))
}